export const stepperHeaderCSS = {
	background: ({ palette }) => palette.grey[100],
	width: 1,
	p: 3,
} as const
